import { BaseModel } from "sjs-base-model";

// Returned Api Data sample
// const example = {
//     userId: 1,
//     firstName: "John",
//     lasyName: "Doe",
//     email: "john@doe.com"
// };

export default class SubscriptionUserModel extends BaseModel {
    userId = "";
    firstName = "";
    lastName = "";
    email = "";
    additionalEmail2 = "";
    additionalEmail3 = "";
    company = "";
    isSubscriptionActive = false;
    isSubscriptionUnrestricted = false;
    isSubscriptionUpcoming = false;
    visibilityStartDate = 0;
    visibilityEndDate = 0;
    trial = false;
    salesTrial = false;

    constructor(data) {
        super();
        this.update(data);
    }
}
